import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  Filter,
  DateField,
  FunctionField,
} from "react-admin";
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";

const RepresentativeFilter = (props) => (
  <Filter {...props}>
    <TextInput label="E-mail" source="email" alwaysOn />
    <TextInput label="Nome" source="name" />
    <TextInput label="Telefone" source="phone" />
    <SelectInput
      label="Função"
      source="roleUser.id"
      choices={[
        { id: "1", name: "Representante" },
        { id: "2", name: "Gerente Distrital" },
      ]}
    />
  </Filter>
);

const RepresentativeList = (props) => (
  <List
    hasCreate={true}
    bulkActionButtons={<div />}
    title="Lista de Representantes"
    exporter={exporter}
    perPage={25}
    actions={<CustomActions />}
    filters={<RepresentativeFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField label="Telefone" source="phone" />
      <TextField label="E-mail" source="email" />
      <FunctionField
      label="Função"
      render={(record) => record.roleUser.id === 1 ? "Representante" : "Gerente Distrital"}
      />
      <DateField label="Data de Cadastro" source="registeredAt" />
    </Datagrid>
  </List>
);

export default RepresentativeList;
